import React from "react";
import { Box, Flex, Text, useTheme, Icon, Skeleton } from "@chakra-ui/react";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import getAxios from "../../hooks/useAxios";
import Nodata from "../../components/Nodata";
import { useNavigate } from "react-router-dom";
import { MdOutlineModeEdit } from "react-icons/md";

function Index() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const navigate = useNavigate();

  const access_token = Cookies.get("x-admin-auth");
  const [coupons, setCoupons] = React.useState<any>([]);
  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const getCoupons = async () => {
    setIsDataFetching(true);

    try {
      const res = await axios.get(`/coupons`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all users", res.data?.data);
      setCoupons(res.data?.data);
    } catch (error) {
      console.log("error listing coupons", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleEditButtonClick = (val: string) => {
    navigate({
      pathname: "/coupons/edit",
      search: `?id=${val}`,
    });
  };

  React.useEffect(() => {
    getCoupons();
  }, []);

  // if (coupons.length === 0)
  //   return (
  //     <Box
  //       style={{
  //         padding: "2rem",
  //       }}
  //     >
  //       <Nodata heading="No Coupons Listed" />
  //     </Box>
  //   );

  return (
    <Box
      style={{
        width: "100%",
        padding: "2rem",
      }}
    >
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          marginBottom: theme.space["3xl"],
        }}
      >
        All Coupons
      </Text>

      <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
        {coupons && coupons.length !== 0 ? (
          <table>
            <thead>
              <tr>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Code
                  </Text>
                </th>

                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Flat Discount(₹)
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Percent Discount(%)
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Start
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    End
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Limit
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Update
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {coupons.map((item: any, index: number) => (
                <tr key={index}>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item.code}
                    </Text>
                  </td>

                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item.flat_discount ? `₹${item.flat_discount}` : "--"}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item.discount_percent
                        ? `${item.discount_percent}%`
                        : "--"}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {new Date(item.start_at).toLocaleString("en-IN")}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {new Date(item.end_at).toLocaleString("en-IN")}
                    </Text>
                  </td>
                  <td>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading2,
                      }}
                    >
                      {item.max_usage}
                    </Text>
                  </td>
                  <td>
                    <Flex
                      sx={{
                        justifyContent: "center",
                        // background: isActive ? theme.colors.bg.main : 'transparent',
                        alignItems: "center",
                        height: "2.8rem",
                        width: "2.8rem",
                        borderRadius: "0.25rem",
                        // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                      }}
                    >
                      <Icon
                        as={MdOutlineModeEdit}
                        width={6}
                        height={6}
                        color={theme.colors.primary.main}
                        cursor="pointer"
                        onClick={() => handleEditButtonClick(item.id)}
                      />
                    </Flex>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Box
            style={{
              padding: "2rem",
            }}
          >
            <Nodata heading="No Coupons Listed" />
          </Box>
        )}
      </Skeleton>
    </Box>
  );
}

export default Index;
